module.exports = __webpack_public_path__ + "static/media/henning.243bf93f.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/crew/henning.png
// module id = 616
// module chunks = 0